import { Component, OnInit, OnDestroy } from '@angular/core';
declare var $: any;
@Component({
  selector: 'cmp-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  ngOnInit(): void {
    $(".loader-item").delay(400).fadeOut();
    $("#pageloader").delay(500).fadeOut("slow");
    // if (window.performance) {
    //   if (performance.navigation.type != 1) {

    //   }
    // }
    // window.addEventListener("beforeunload", this.clearLocalStorage);
    // window.addEventListener("unload", this.clearLocalStorage);
    // if (localStorage.getItem('AToken') && localStorage.getItem('AToken') !== '' && (!sessionStorage.getItem('SToken') || sessionStorage.getItem('SToken') === '')) {
    //   alert("Another session is opened in same browser and hence this session is terminated.");
    // }
    // if (!window.location.href.includes('thank-you') && !window.location.href.includes('sorry') && sessionStorage.getItem('SToken') && sessionStorage.getItem('SToken') !== '') {
    //   alert("Refresh action is not allowed on this application and hence current session is terminated. Please try again.");
    //   sessionStorage.clear();
    //   localStorage.clear();
    // }
  }

  clearLocalStorage() {
    if (sessionStorage.getItem('SToken') && sessionStorage.getItem('SToken') !== '') {
      localStorage.clear();
    }
  }

}
